<template>
  <el-dialog title="角色授权" :visible.sync="visible" width="600px" destroy-on-close>
    <el-form ref="searchForm" :model="searchForm" :inline="true" size="mini" @submit.native.prevent>
      <el-form-item label="角色组/角色名称:" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入筛选条件" clearable />
      </el-form-item>
    </el-form>
    <el-tree
      ref="tree"
      :data="options"
      show-checkbox
      node-key="busRoleId"
      :props="defaultProps"
      default-expand-all
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      check-on-click-node
      style="max-height: 500px;overflow: auto"
    />
    <div slot="footer" class="dialog-footer text-center">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { choseRoleTreeData } from '@/api/common'
export default {
  name: 'UmBusRole',
  data() {
    return {
      roleType: [1003501, 1003502],
      roleNature: [1003511, 1003512, 1003513],
      visible: false,
      options: [],
      checkedList: [],
      searchForm: {
        name: ''
      },
      defaultProps: {
        children: 'children',
        label: 'roleName'
      }
    }
  },
  watch: {
    'searchForm.name'(val) {
      this.$refs.tree.filter(val)
    },
    checkedList(val) {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(val)
      })
    }
  },
  created() {
    this.getTree()
  },
  methods: {
    init(list) {
      list.forEach(item => {
        if (item.children) {
          this.init(item.children)
        }
        if (item.children.length === 0 && item.roleType == 1003501) {
          item.disabled = true
        }
      })
    },
    handleAfterLeave() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el) // 可能移除的时候组件已经不存在了
    },
    submit() {
      this.$emit('change', this.$refs.tree.getCheckedKeys(true))
      this.visible = false
      this.handleAfterLeave()
    },
    filterNode(value, data) {
      if (!value) return true
      return data.roleName.indexOf(value) !== -1
    },
    getTree() {
      choseRoleTreeData({
        filterRoleType: this.roleType,
        filterRoleNature: this.roleNature
      }).then(d => {
        console.log(d)
        const list = d.data
        this.init(list)
        this.options = list
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.checkedList)
        })
      })
    }
  }
}
</script>
